import { Display3 } from '@sainsburys-tech/fable'
import React from 'react'

import { IOvenSettingDetail } from '../../types/IOvenSettingDetail'
// import OvenTypeDescription from './OvenTypeDescription'

interface IMixSkuCardTitleProps {
  plannerGroupName: string
  ovenSettingDetail?: IOvenSettingDetail
}

const MixSkusTitle = ({
  plannerGroupName,
  ovenSettingDetail,
}: IMixSkuCardTitleProps) => {
  return (
    <>
      <Display3>
        {!ovenSettingDetail
          ? plannerGroupName
          : ovenSettingDetail.ovenSettingDescription}
      </Display3>

      {/* <OvenTypeDescription ovenSettingDetail={ovenSettingDetail} />  */}
    </>
  )
}

export default MixSkusTitle
